import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

// Ojo: BASE_URL va sin sufijo /api (ver CLAUDE.md), y la convencion mayoritaria
// del proyecto es armar las urls como `${BASE_URL}/recurso`.

const authConfig = (user) => ({
  headers: {
    Authorization: `Bearer ${user.token}`,
  },
});

// Los errores del back vienen en `detail`; lo propagamos para poder mostrar el
// motivo real (mail duplicado, ultimo admin, etc.) en lugar de un mensaje generico.
const errorFrom = (err, fallback) => {
  const detail = err?.response?.data?.detail;
  return new Error(typeof detail === "string" ? detail : fallback);
};

export const getAdmins = async (user) => {
  try {
    const response = await axios.get(`${BASE_URL}/admins`, authConfig(user));
    return response.data;
  } catch (err) {
    console.error(`Error when getting admins: ${err}`);
    throw errorFrom(err, "Error al obtener los administradores");
  }
};

export const addAdmin = async (newAdmin, user) => {
  const body = {
    name: newAdmin.name,
    last_name: newAdmin.last_name,
    email: newAdmin.email,
    password: newAdmin.password,
  };
  try {
    const response = await axios.post(
      `${BASE_URL}/admins`,
      body,
      authConfig(user)
    );
    return response.data;
  } catch (err) {
    console.error(`Error when adding new admin: ${err}`);
    throw errorFrom(err, "Error al crear el administrador");
  }
};

export const editAdmin = async (adminId, adminToEdit, user) => {
  // El PATCH ignora los campos ausentes, asi que la contraseña vacia significa
  // "no cambiarla" y no se manda.
  const body = {
    name: adminToEdit.name,
    last_name: adminToEdit.last_name,
    email: adminToEdit.email,
  };
  if (adminToEdit.password) {
    body.password = adminToEdit.password;
  }
  try {
    const response = await axios.patch(
      `${BASE_URL}/admins/${adminId}`,
      body,
      authConfig(user)
    );
    return response.data;
  } catch (err) {
    console.error(`Error when editing admin: ${err}`);
    throw errorFrom(err, "Error al editar el administrador");
  }
};

export const deleteAdmin = async (adminId, user) => {
  try {
    const response = await axios.delete(
      `${BASE_URL}/admins/${adminId}`,
      authConfig(user)
    );
    return response.data;
  } catch (err) {
    console.error(`Error when deleting admin: ${err}`);
    throw errorFrom(err, "Error al eliminar el administrador");
  }
};

export const getPromotableTutors = async (user) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/admins/promotable`,
      authConfig(user)
    );
    return response.data;
  } catch (err) {
    console.error(`Error when getting promotable tutors: ${err}`);
    throw errorFrom(err, "Error al obtener los tutores");
  }
};

// Promover no crea un usuario nuevo ni toca la contraseña: le cambia el rol al
// mismo usuario, que conserva sus TutorPeriod. Es el responsable de la materia.
export const promoteToAdmin = async (userId, user) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/admins/${userId}/promote`,
      {},
      authConfig(user)
    );
    return response.data;
  } catch (err) {
    console.error(`Error when promoting user to admin: ${err}`);
    throw errorFrom(err, "Error al promover el tutor a administrador");
  }
};

export const demoteToTutor = async (adminId, user) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/admins/${adminId}/demote`,
      {},
      authConfig(user)
    );
    return response.data;
  } catch (err) {
    console.error(`Error when demoting admin to tutor: ${err}`);
    throw errorFrom(err, "Error al bajar el administrador a tutor");
  }
};
